import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Balance from '../views/Balance.vue'
import Map from '../components/Map.vue'
import Login from '../components/Login.vue'
import LoginByCode from '../components/LoginByCode.vue'
import Singup from '../components/Singup.vue'
import Cards from '../components/Cards.vue'
import PayoffOrder from '../components/PayoffOrder.vue'
import PayoffOrders from '../components/PayoffOrders.vue'
import Acceptance from '../components/Acceptance.vue'
import Acceptances from '../components/Acceptances.vue'
import AcceptancesTable from '../components/AcceptancesTable.vue'
import Deliveries from '../components/Deliveries.vue'
import UsersDelivery from '../components/UsersDelivery.vue'
import UsersReceive from '../components/UsersReceive.vue'
import Transfer from '../components/Transfer.vue'
import Transfers from '../components/Transfers.vue'
import Prices from '../components/Prices.vue'
import BonusReceiver from '../components/BonusReceiver.vue'
import ReportMaster from '../components/ReportMaster.vue'
import Profile from '../components/Profile.vue'
import WriteOffs from '../components/WriteOffs.vue'
import Shipment from '../components/Shipment.vue'
import Shipments from '../components/Shipments.vue'
import Berries from '../components/Berries.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/balance',
    name: 'balance',
    component: Balance,
  },
  {
    path: '/map',
    name: 'map',
    component: Map,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/loginByCode',
    name: 'loginByCode',
    component: LoginByCode,
  },
  {
    path: '/singup',
    name: 'singup',
    component: Singup,
  },
  {
    path: '/cards',
    name: 'cards',
    component: Cards,
  },
  {
    path: '/payofforder',
    name: 'payofforder',
    props: true,
    component: PayoffOrder,
  },
  {
    path: '/payofforders',
    name: 'payofforders',
    component: PayoffOrders,
  },
  {
    path: '/acceptance/:id',
    props: true,
    name: 'acceptance',
    component: Acceptance,
  },
  {
    path: '/transfer/:id',
    props: true,
    name: 'transfer',
    component: Transfer,
  },
  {
    path: '/shipment/:id',
    props: true,
    name: 'shipment',
    component: Shipment,
  },
  {
    path: '/shipments',
    name: 'shipments',
    component: Shipments,
  },
  {
    path: '/acceptances',
    name: 'acceptances',
    component: Acceptances,
  },
  {
    path: '/acceptancesTable',
    name: 'acceptancesTable',
    component: AcceptancesTable,
  },
  {
    path: '/transfers',
    name: 'transfers',
    component: Transfers,
  },
  {
    path: '/writeoffs',
    name: 'writeoffs',
    component: WriteOffs,
  },
  {
    path: '/deliveries',
    name: 'deliveries',
    component: Deliveries,
  },
  {
    path: '/usersDelivery',
    name: 'usersDelivery',
    component: UsersDelivery,
  },
  {
    path: '/usersReceive',
    name: 'usersReceive',
    component: UsersReceive,
  },
  {
    path: '/prices',
    name: 'prices',
    component: Prices,
  },
  {
    path: '/bonusReceiver',
    name: 'bonusReceiver',
    component: BonusReceiver,
  },
  {
    path: '/reportMaster',
    name: 'reportMaster',
    component: ReportMaster,
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
  },
  {
    path: '/berries',
    name: 'berries',
    component: Berries,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
